import React from 'react';
import Feature from '../../components/feature/Feature';
import './whatWoix.css';

const WhatWoix = () => (
  <div className="gpt3__whatgpt3 section__margin" id="wgpt3">
    <div className="gpt3__whatgpt3-feature">
      <Feature title="What is Woix?" text="At Woix, we believe that every challenge presents an opportunity to create something extraordinary. Our team of passionate developers, designers, and tech enthusiasts is committed to translating your ideas into reality." />
    </div>
    <div className="gpt3__whatgpt3-heading">
      <h1 className="gradient__text">The possibilities are beyond your imagination.</h1>
      <p>Explore the Library</p>
    </div>
    <div className="gpt3__whatgpt3-container">
      <Feature title="Vision" text="Empowering Visions Through Code"/>
      <Feature title="Knowledgebase" text="Our passion lies in transforming creative ideas into cutting-edge software solutions that transcend expectations. With our unwavering commitment to excellence, we specialize in crafting a wide spectrum of digital experiences." />
      <Feature title="What Sets Us Apart?" text="Unparalleled Expertise: Our seasoned experts bring a wealth of experience to the table, ensuring top-notch solutions that align with the latest industry trends. We view our clients as partners. Your insights combined with our technical prowess result in solutions that truly resonate with your audience." />
    </div>
  </div>
);

export default WhatWoix;